var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEverycredWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4834",
    "data-name": "Group 4834",
    transform: "translate(-335 -476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 25,
    height: 25,
    rx: 5,
    transform: "translate(335 476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "final-logo-icon",
    transform: "translate(329.912 473.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4831",
    "data-name": "Group 4831",
    transform: "translate(11.2 5.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "everycred",
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M7.928,18h0l-1.585-.933L0,13.43V4.57L6.342.932,7.928,0l4.849,2.8V7.834l-4.849-2.8L4.337,7.088v3.824l3.591,2.052,4.849-2.8V15.2L7.928,18Zm0-16.275h0l-.979.559L1.493,5.549v6.9l5.456,3.264.979.56,3.544-2.052V12.4L7.928,14.456l-4.85-2.8V6.342l4.85-2.8L11.472,5.6V3.777L7.928,1.725Z",
    fill: "#083f85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4832",
    "data-name": "Group 4832",
    transform: "translate(16.982 12.321)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "everycred",
    id: "XMLID_64_",
    d: "M24.253,23.957l-.653-.373V21.112l2.145,1.259V24.8h0V22.371l2.145-1.259L25.745,19.9h0L23.6,21.112v2.471h0Z",
    transform: "translate(-23.6 -19.9)",
    fill: "#083f85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "everycred",
    id: "XMLID_63_",
    d: "M28.2,23.759v2.425l2.145-1.212V22.5Z",
    transform: "translate(-26.055 -21.288)",
    fill: "#083f85",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "everycred",
    id: "XMLID_62_",
    d: "M23.6,22.5v2.471l.653.373,1.492.839h0V23.759Z",
    transform: "translate(-23.6 -21.288)",
    fill: "#083f85",
    opacity: 0.6
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverycredWallet);
export default __webpack_public_path__ + "static/media/everycred-wallet.7ab3dc79.svg";
export { ForwardRef as ReactComponent };